export const CHECK_USER_COVERAGE_AREA_SUPPORT =
  "/v1/polygon/{{storeId}}/{{langCode}}/coverageArea/isSupported";

export const GET_QATAR_ZONES = "/v1/content/address/areas";

export const USER_ADDRESS_API = "/v2/addresses/{{storeId}}/{{langCode}}";
